import type { Slide } from '../../types';

import { SLIDES } from './mockData';

export const getSlides = (): Slide[] => {
  return SLIDES;
};
